import React, { useState, useEffect } from "react";
import { createTender, updateTender, getTenderById } from "../../services/tenderService";
import { Link,useNavigate, useParams } from "react-router-dom";

export default function TenderForm() {
  const [formData, setFormData] = useState({
    Title: "",
    Description: "",
    PublishDate: "",
    ClosingDate: "",
    CreatedBy: "Admin",
    File: null,
  });

  const { id } = useParams();
  const navigate = useNavigate();

  // ✅ Load tender when editing
  useEffect(() => {
    if (id) {
      (async () => {
        const tender = await getTenderById(id);
        setFormData({
          Title: tender.title,
          Description: tender.description,
          PublishDate: tender.publishDate?.split("T")[0],
          ClosingDate: tender.closingDate?.split("T")[0],
          CreatedBy: tender.createdBy,
          File: null,
        });
      })();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, File: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await updateTender(id, formData);
        alert("Tender updated successfully!");
      } else {
        await createTender(formData);
        alert("Tender created successfully!");
      }
      navigate("/admin/tenders");
    } catch (err) {
      console.error(err);
      alert("Error submitting tender form!");
    }
  };

  return (
    <div className="container mt-4">
      <h3>{id ? "Edit Tender" : "Create Tender"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Title</label>
          <input
            type="text"
            name="Title"
            className="form-control"
            value={formData.Title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Description</label>
          <textarea
            name="Description"
            className="form-control"
            value={formData.Description}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="mb-3">
          <label>Publish Date</label>
          <input
            type="date"
            name="PublishDate"
            className="form-control"
            value={formData.PublishDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Closing Date</label>
          <input
            type="date"
            name="ClosingDate"
            className="form-control"
            value={formData.ClosingDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Upload File</label>
          <input type="file" className="form-control" onChange={handleFileChange} />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Update" : "Create"}
        </button>
       <Link to="/admin/tenders" className="btn btn-primary">
          Back List
        </Link>
      </form>
        
    </div>
  );
}
